<template>
  <div class="login">
    <home-header :isShow="false"></home-header>
    <div class="center_bg">

      <div class="login_left">
        <img src="../assets/images/login_bannerimg.png"/>
      </div>

      <div style="flex: 1;"></div>

      <div class="center">
        <div class="frombox">
          <div class="sjhForm" >
            <el-form :model="formModel" :rules="rules" ref="form">
              
              <el-form-item  prop="mobile">
                <el-input
                  placeholder="请输入手机号"
                  v-model="formModel.mobile"
                  clearable
                >
                </el-input>
              </el-form-item>

              <el-form-item class="code"  prop="code" >
                <el-col :span="14">
                  <el-input
                    oninput="value=value.replace(/[^\d]/g,'')"
                    placeholder="请输入验证码"
                    v-model="formModel.code"
                    clearable
                  ></el-input>
                </el-col>
                <el-col :span="3">
                 <div>&nbsp;</div>
                </el-col>
                <el-col :span="7" class="code_box">
                  <el-button class="code_btn" type="button" @click="sendcode" :disabled="disabled" v-if="disabled==false">发送验证码
                  </el-button>
                  <el-button class="code_btn" type="button" @click="sendcode" :disabled="disabled" v-if="disabled==true">{{btntxt}}
                  </el-button>
                </el-col>
              </el-form-item>

              <el-form-item  prop="password">
                <el-input
                  placeholder="请输入密码"
                  v-model="formModel.password"
                  show-password
                ></el-input>
              </el-form-item>

              <el-form-item  prop="password_repetition">
                <el-input
                  placeholder="请确认密码"
                  v-model="formModel.password_repetition"
                  show-password
                ></el-input>
              </el-form-item>

            </el-form>

            <div class="links">
              <router-link to="/login">
                <el-link :underline="false">已有账号，<span style="color: #3370ff;">马上登录</span></el-link>
              </router-link>
            </div>

            <div class="dl"  @click="changeData('form')">确认修改</div>
          </div>
        </div>
      </div>
    </div>
    <login-footer></login-footer>
  </div>

</template>


<script>
    // import HomeHeader from '@/components/Header'
    import HomeHeader from '@/components/homeHeader' 

    import LoginFooter from '@/components/LoginFooter'
    export default {
        name: "Reset",
        components: {

            HomeHeader,
            LoginFooter
        },
    data() {
      // 手机验证
      var validateMobilePhone = (rule, value, callback) => {
          if (value === "") {
              callback(new Error("手机号不可为空"));
          } else {
              if (value !== "") {
                  var reg = /^1[3456789]\d{9}$/;
                  if (!reg.test(value)) {
                      callback(new Error("请输入有效的手机号码"));
                  }
              }
              callback();
          }
      };
      // 密码验证
      var validatePass = (rule, value, callback) => {
          const pwdReg = /^(?=.*\d)(?=.*[a-zA-Z]).{8,}$/;
          if (!value) {
              return callback(new Error("请输入密码"));
          } else if (pwdReg.test(value)) {
              callback();
          } else {
              callback(new Error("请输入包含数字字母的不低于8位数的密码"));
          }
      };
      // 重复密码验证
      var validatePass2 = (rule, value, callback) => {
          if (value === '') {
              callback(new Error('请再次输入密码'))
              // password 是表单上绑定的字段
          } else if (value !== this.formModel.password) {
              callback(new Error('两次输入密码不一致!'))
          } else {
              callback()
          }
      }
    return {
        disabled: false,
        time: 0,
        btntxt: "重新发送",
      formModel: {
        mobile: "",
        password: "",
        password_repetition: "",
        code: "",
        group: "pc"
      },
        rules: {
            mobile: [
                {
                    required: true,
                    validator: validateMobilePhone,
                    trigger: "change",
                },
            ],
            password: [
                { required: true, validator: validatePass, trigger: "change" },
            ],
            password_repetition: [
                { required: true, validator: validatePass2, trigger: 'blur' }
            ],
            code: [
                { required: true, message: '请输入验证码' },
            ]
            
        }
    };
  },
  methods: {
      //手机验证发送验证码
      sendcode() {
          const reg = 11 && /^((13|14|15|17|18)[0-9]{1}\d{8})$/
          if (this.formModel.mobile == '') {
              this.$message({
                  message:'手机号不能为空',
                  center: true
              })
              return
          }
          if (!reg.test(this.formModel.mobile)) {
              this.$message({
                  message:'请输入正确的手机号',
                  center:true
              })
              return
          } else {
              var data={
                  mobile:this.formModel.mobile,
                  usage:'up-pwd'
              }
              this.$api.sendCode(data).then(res => {
                  //数据处理
                  this.$message({
                      message: '发送成功',
                      type: 'success',
                      center:true
                  });
                  this.time = 60;
                  this.disabled = true;
                  this.timer();
              }).catch(err => console.log(err))
          }
      },
      //60S倒计时
      timer() {
          if (this.time > 0) {
              this.time--;
              this.btntxt = this.time + "s后重新获取";
              setTimeout(this.timer, 1000);
          } else {
              this.time = 0;
              this.btntxt = "获取验证码";
              this.disabled = false;
          }
      },
      //完成
      changeData(form){
          this.$refs[form].validate((valid) => {
              console.log(valid)
              if (valid) {
                  this.doReset ()
              } else {
                  console.log('error submit!!');
                  return false;
              }
          });
      },
      //重置
      resetForm(formName) {
          this.$refs[formName].resetFields();
      },
      doReset () {
          this.$api.reset(this.$data.formModel).then(res => {
              //数据处理
              this.$message.success('修改成功')
              this.$router.replace({
                  path: '/login',
              });
          }).catch(err => console.log(err))
      },
  }
};
</script>

<style scoped>
.login {
  width: 100%;
  position: relative;
}
.center_bg{
  width: 100%;
  /* background: #6BC96B; */
  background: linear-gradient(180deg,  #2e92fe,#3370ff);

  background-size: 100%;
  box-sizing: border-box;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  padding: 0px 400px;
  box-sizing: border-box;
}

.title {
  text-align: center;
}
.title div {
  height: 40px;
  font-size: 40px;
  font-family: Microsoft YaHei;
  font-weight: bold;
  color: #ffffff;
  margin-bottom: 20px;
}
.title span {
  width: 153px;
  height: 14px;
  font-size: 14px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #ffffff;
}
.frombox {
  background: #ffffff;
  border-radius: 10px;
  padding: 15px 0px 20px 0px;
  box-sizing: border-box;
}
.sjhForm{
  margin-top: 40px;
}
.el-menu--horizontal>.el-menu-item.is-active {
  background: #3370ff !important;
  color: #ffffff !important;
  border-bottom: none;
}
.el-button:focus, .el-button:hover{
  background: none !important;
}
.btns{
  width: 300px;
  height: 40px;
  background: #f6f6f6;
  border-radius: 20px;
  margin: 0px auto;
  display: flex;
}
.el-button {
  height: 40px;
  width: 100px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 5px;
  background: none;
  border: none;
  color: #999999;
  border: 1px solid #EEEEEE;
}
.el-button+.el-button {
  margin: 0px !important;
}
.el-link {
  font-size: 12px;
  font-family: Microsoft YaHei;
  font-weight: 400;
}

.frombox >>> .el-input__inner {
  border-top: none;
  border-bottom: 1px solid #eeeeee;
  border-left: none;
  border-right: none;
}
.dl {
  background: #3370ff;
  font-size: 16px;
  font-family: Microsoft YaHei;
  font-weight: bold;
  color: #ffffff;
  margin: 40px auto 0px auto;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}
.ewm{
 text-align: center;
  margin-top: 25px;
}
.login_left img{
  width: 350px;
}

@media (min-width: 1024px){
      .center_bg{
        height: 620px;
      }
      .frombox {
        width: 460px;
        height: 550px;
      }
      .el-form,
      .links {
        width: 350px;
        margin: 10px auto;
      }
      .el-form-item {
        margin-bottom: 35px;
      }
      .dl {
        width: 350px;
        height: 50px;
        border-radius: 25px;
      }
    } /*>=1024的设备*/

    @media (min-width: 1100px) {
    
    } /*>=1100的设备*/
    @media (min-width: 1280px) {
      .center_bg{
        height:510px ;
      }
      .frombox {
        width: 400px;
        height: 450px;
      }
      .el-form,
      .links {
        width: 300px;
        margin: 10px auto;
      }
      .el-form-item {
        margin-bottom: 20px;
      }
      .dl {
        width: 300px;
        height: 40px;
        border-radius: 20px;
      }
    } /*>=1280的设备*/



</style>



// WEBPACK FOOTER //
// src/resetpassword/reset.vue